import type { CSSProperties } from 'react';

import type { EditorCollectionItemDragData } from '@/components/blocks/editor/collection/collection-dnd';
import type { CollectionCardConfig, CollectionItem } from '@/lib/blocks/collection/blocks';
import type { CollectionMediaLayout } from '@/lib/blocks/collection/media-layout';
import { alternatingImagePosition, CollectionCard } from '../../../collection/collection-card';
import { makeEditorRenderField } from '../item-fields';
import { SortableCardBody, SortableCollectionCardRoot } from './card-shell';

export type SortableAlternatingCardProps = {
  item: CollectionItem;
  index: number;
  sortIndex: number;
  totalCount: number;
  cardConfig: CollectionCardConfig;
  mediaLayout: CollectionMediaLayout;
  paddingClassName?: string;
  cardStyle?: CSSProperties;
  collectionSortableGroup: string;
  collectionItemDragData: EditorCollectionItemDragData;
  disabled?: boolean;
  actionsDisabled?: boolean;
  onUpdate: (updated: CollectionItem, commit?: boolean) => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onSelectionChange?: (selected: boolean) => void;
  primarySelected?: boolean;
};

export function SortableAlternatingCard({
  item,
  index,
  sortIndex,
  totalCount,
  cardConfig,
  mediaLayout,
  paddingClassName,
  cardStyle,
  collectionSortableGroup,
  collectionItemDragData,
  disabled,
  actionsDisabled,
  onUpdate,
  onDelete,
  onDuplicate,
  onSelectionChange,
  primarySelected,
}: SortableAlternatingCardProps) {
  return (
    <SortableCollectionCardRoot
      item={item}
      totalCount={totalCount}
      sortIndex={sortIndex}
      collectionSortableGroup={collectionSortableGroup}
      collectionItemDragData={collectionItemDragData}
      disabled={disabled}
      actionsDisabled={actionsDisabled}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onSelectionChange={onSelectionChange}
      primarySelected={primarySelected}
    >
      <SortableCardBody cardStyle={cardStyle}>
        <CollectionCard
          item={item}
          cardConfig={cardConfig}
          mediaLayout={{ ...mediaLayout, position: alternatingImagePosition(index) }}
          sideBySideMode="alternating"
          paddingClassName={paddingClassName}
          renderField={makeEditorRenderField(item, onUpdate, Boolean(disabled))}
        />
      </SortableCardBody>
    </SortableCollectionCardRoot>
  );
}
